import _typeof from "@babel/runtime/helpers/typeof";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import ReactVertexReconciler, { SceneNode } from './Reconciler';
import ReactVertexContext from './Context';

var Canvas =
/*#__PURE__*/
function (_Component) {
  _inherits(Canvas, _Component);

  function Canvas() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Canvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Canvas)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      error: false,
      message: ''
    };
    _this.canvas = createRef();

    _this.renderScene = function () {
      if (_this.sceneNode) {
        _this.sceneNode.render();
      }
    };

    return _this;
  }

  _createClass(Canvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var current = this.canvas.current;
      var _this$props = this.props,
          webgl1 = _this$props.webgl1,
          webgl2 = _this$props.webgl2,
          clearColor = _this$props.clearColor,
          children = _this$props.children,
          antialias = _this$props.antialias,
          textureFlip = _this$props.textureFlip,
          _this$props$contextAt = _this$props.contextAttrs,
          contextAttrs = _this$props$contextAt === void 0 ? {} : _this$props$contextAt,
          _this$props$extension = _this$props.extensions,
          extensions = _this$props$extension === void 0 ? [] : _this$props$extension,
          renderOnUpdate = _this$props.renderOnUpdate;

      var attrs = _objectSpread({
        antialias: antialias
      }, contextAttrs);

      var gl, webglVersion;

      if (webgl2) {
        gl = current.getContext('webgl2', attrs);
        webglVersion = 2;
      }

      if (!gl && webgl1) {
        gl = current.getContext('webgl', attrs);
        webglVersion = 1;
      }

      if (!gl) {
        this.setState({
          error: true,
          message: 'Could not create WebGL context.'
        });
        return;
      }

      textureFlip && gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      this.sceneNode = new SceneNode(current, extensions, gl);
      this.sceneNode.webglVersion = webglVersion;
      this.sceneNode.clearColor = clearColor;
      this.sceneNode.renderOnUpdate = renderOnUpdate;

      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object') {
        window.sceneNode = this.sceneNode;
      }

      var _this$updateDimension = this.updateDimensions(),
          width = _this$updateDimension.width,
          height = _this$updateDimension.height;

      this.contextObject = {
        scene: this.sceneNode,
        width: width,
        height: height
      };
      this.container = ReactVertexReconciler.createContainer(this.sceneNode);
      ReactVertexReconciler.updateContainer(React.createElement(ReactVertexContext.Provider, {
        value: this.contextObject
      }, children), this.container, this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var children = this.props.children;

      var _this$updateDimension2 = this.updateDimensions(),
          width = _this$updateDimension2.width,
          height = _this$updateDimension2.height,
          update = _this$updateDimension2.update;

      if (update) {
        this.contextObject = _objectSpread({}, this.contextObject, {
          width: width,
          height: height
        });
      }

      ReactVertexReconciler.updateContainer(React.createElement(ReactVertexContext.Provider, {
        value: this.contextObject
      }, children), this.container, this);
    }
  }, {
    key: "updateDimensions",
    value: function updateDimensions() {
      var current = this.canvas.current;
      var _this$props2 = this.props,
          width = _this$props2.width,
          height = _this$props2.height,
          renderOnResize = _this$props2.renderOnResize;
      var devicePixelRatio = window.devicePixelRatio || 1;
      var nextWidth = Math.round(width * devicePixelRatio);
      var nextHeight = Math.round(height * devicePixelRatio);
      var update = nextWidth !== current.width || nextHeight !== current.height;

      if (update) {
        current.style.width = "".concat(width, "px");
        current.style.height = "".concat(height, "px");
        current.width = nextWidth;
        current.height = nextHeight;
        renderOnResize && this.sceneNode.requestRender();
      }

      return {
        width: nextWidth,
        height: nextHeight,
        update: update
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      ReactVertexReconciler.updateContainer(null, this.container, this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          _this$props3$canvasCl = _this$props3.canvasClass,
          canvasClass = _this$props3$canvasCl === void 0 ? '' : _this$props3$canvasCl,
          _this$props3$canvasSt = _this$props3.canvasStyle,
          canvasStyle = _this$props3$canvasSt === void 0 ? {} : _this$props3$canvasSt;
      return React.createElement("canvas", {
        ref: this.canvas,
        className: canvasClass,
        style: canvasStyle
      });
    }
  }]);

  return Canvas;
}(Component);

export { Canvas as default };
Canvas.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  webgl1: PropTypes.bool,
  webgl2: PropTypes.bool,
  antialias: PropTypes.bool,
  textureFlip: PropTypes.bool,
  clearColor: PropTypes.array.isRequired,
  canvasClass: PropTypes.string,
  canvasStyle: PropTypes.object,
  extensions: PropTypes.arrayOf(PropTypes.string),
  contextAttrs: PropTypes.object,
  renderOnUpdate: PropTypes.bool,
  renderOnResize: PropTypes.bool
};
Canvas.defaultProps = {
  clearColor: [0, 0, 0, 1],
  webgl1: true,
  webgl2: false,
  antialias: false,
  textureFlip: true,
  renderOnUpdate: false,
  renderOnResize: true
};